<template>
  <div class="auth-wrapper auth-v1">
    <div class="auth-inner">
      <b-card class="m-0 p-2">
        <b-tabs fill>
          <b-tab active title="ورود با نام کاربری">
            <b-card-text class="pt-1">
              <b-form class="auth-login-form" @submit.prevent>
                <b-form-input v-model="loginData.username" placeholder="نام کاربری" class="text-center" />
                <b-form-input v-model="loginData.password" dir="ltr" placeholder="رمز عبور" type="password"
                  class="text-center mt-2"></b-form-input>
                <b-button type="submit" variant="primary" block @click="login" :disabled="buttonLoading"
                  class="mt-2 py-1">
                  <span v-if="!buttonLoading" style="font-size: 16px;">ورود به پنل</span>
                  <b-spinner v-else variant="white" small></b-spinner>
                </b-button>
              </b-form>
            </b-card-text>
          </b-tab>
          <b-tab title="ورود با شماره‌ی همراه">
            <b-card-text class="pt-1">
              <b-form class="auth-login-form" @submit.prevent>
                <b-form-input v-model="loginDataWithPhoneNumber.phoneNumber" placeholder="شماره همراه"
                  class="text-center" dir="ltr" />
                <b-form-input v-model="loginDataWithPhoneNumber.code" placeholder="کد تایید" type="password" dir="ltr"
                  class="text-center mt-2" :disabled="!codeIsActive" />
                <b-button type="submit" variant="primary" block @click="loginWithPhoneNumber" :disabled="buttonLoading"
                  class="mt-2 py-1">
                  <span v-if="!buttonLoading" style="font-size: 16px;">ورود به پنل</span>
                  <b-spinner v-else variant="white" small></b-spinner>
                </b-button>
              </b-form>
            </b-card-text>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import { BFormInput, BCard, BCardText, BCardTitle, BForm, BButton, BSpinner, BTabs, BTab } from 'bootstrap-vue';

export default {
  components: {
    BSpinner,
    BFormInput,
    BCardText,
    BCardTitle,
    BCard,
    BForm,
    BButton,
    BTabs,
    BTab,
  },
  data() {
    return {
      buttonLoading: false,
      loginData: {
        username: '',
        password: null,
      },
      loginDataWithPhoneNumber: {
        phoneNumber: '',
        code: null,
      },
      codeIsActive: false,
    };
  },
  watch: {
    'loginDataWithPhoneNumber.phoneNumber'(value) {
      if (value.length == 11) {
        this.sendCode()
      }
    }
  },
  methods: {
    async login() {
      this.buttonLoading = true
      await this.$axios.post('/admin/auth/login', this.loginData).then((data) => {
        localStorage.setItem("accessToken", data.data.accessToken);
        localStorage.setItem("refreshToken", data.data.refreshToken);
        this.$router.push(`/`)
      })
        .catch((err) => {
          this.buttonLoading = false
        });
    },
    async loginWithPhoneNumber() {
      this.buttonLoading = true
      await this.$axios.post('admin/auth/loginWithOtp', this.loginDataWithPhoneNumber).then((data) => {
        localStorage.setItem("accessToken", data.data.accessToken);
        localStorage.setItem("refreshToken", data.data.refreshToken);
        this.$router.push(`/`)
      })
        .catch((err) => {
          this.buttonLoading = false
        });
    },
    async sendCode() {
      await this.$axios.post('admin/auth/sendCode', { phoneNumber: this.loginDataWithPhoneNumber.phoneNumber }).then((data) => {
        this.$notif({ type: 'success', title: 'کد تایید را وارد کنید' });
        this.codeIsActive = true
      })
    },
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
